// extracted by mini-css-extract-plugin
export default {"slider":"Reviews_slider__4qgbq","desktopSlider":"Reviews_desktopSlider__PVwQr"};